<template>
  <div id="app">
    <div class="main-section">
      <div class="content">
        <div class="main-content dashboard-margin">
          <div class="today-dashboard content-here">
            <page-dailydashboard />
          </div>

          <!-- eo todays dashboard -->

          <div class="weekly-dashboard content-here">
            <page-weeklydashboard />
          </div>
          <!-- eo this week dashboard -->

          <!-- <div class="monthly-dashboard content-here">
            <page-monthlydashboard />
          </div>-->
          <!-- eo this months dashboard -->
        </div>
        <!-- end of main content -->
      </div>
    </div>

    <div class="footer">
      <p>© ekghanti 2020</p>
    </div>
  </div>
</template>

<script>
import dailydashboard from "./parts/dashboardday";
import weeklydashboard from "./parts/dashboardweek";
import monthlydashboard from "./parts/dashboardmonth";

export default {
  components: {
    "page-dailydashboard": dailydashboard,
    "page-weeklydashboard": weeklydashboard,
    "page-monthlydashboard": monthlydashboard
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/dashboard.vue